<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="tile is-ancestor">
        <div class="tile is-4 is-vertical is-parent">
          <div class="tile is-child box">
            <p class="title is-3">Jógyakorlatok</p>
            <p class="subtitle is-6">Böngésszen a jógyakorlatok között témakörök szerint</p>
            <router-link :to="{ name: 'list-best-practice-topics' }" class="button is-primary is-block">
              Jógyakorlatok &nbsp;
              <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
            </router-link>

            <hr>
            <p class="title is-3">Keresés</p>
            <p class="subtitle is-6">Keressen a jógyakorlatok között kulcsszavak és tartalom alapján</p>
            <router-link :to="{ name: 'list-best-practices' }" class="button is-info is-block">
              Keresés &nbsp;
              <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
            </router-link>

            <hr>
            <p class="title is-3">Képzések</p>
            <p class="subtitle is-6">Következő képzések időponja és jelentkezés</p>
            <router-link :to="{ name: 'trainings' }" class="button is-success is-block">
              Képzések &nbsp;
              <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
            </router-link>

            <hr>
            <p class="title is-3">Beküldés</p>
            <p class="subtitle is-6">Küldjön nekünk jógyakorlatokat</p>
            <router-link :to="{ name: 'contribute' }" class="button is-link is-block">
              Beküldés &nbsp;
              <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
            </router-link>

          </div>
        </div>

        <div class="tile is-parent">
          <div class="tile is-child box">
            <div class="content" v-if="!isLoading">
              <markdown>{{ pageContent }}</markdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'
  /* Components */
  import ProjectLogos from '@/components/General/ProjectLogos'
  import Loader from '@/components/General/Loader'

  export default {
    components: {
      ProjectLogos,
      Loader
    },
    data () {
      return {
        pageContent: '',
        isLoading: true
      }
    },
    async mounted () {
      /* Get content */
      this.pageContent = (await Contentful.getAllEntriesByContentType('pageHome')).data.items[0].fields.pageContent
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pages/Home.vue